var React = require('react');

function ArrowRightIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 9.40464C1.66863 9.40464 1.4 9.67327 1.4 10.0046C1.4 10.336 1.66863 10.6046 2 10.6046L2 9.40464ZM18.4243 10.4289C18.6586 10.1946 18.6586 9.81469 18.4243 9.58038L14.6059 5.762C14.3716 5.52768 13.9917 5.52768 13.7574 5.762C13.523 5.99631 13.523 6.37621 13.7574 6.61053L17.1515 10.0046L13.7574 13.3988C13.523 13.6331 13.523 14.013 13.7574 14.2473C13.9917 14.4816 14.3716 14.4816 14.6059 14.2473L18.4243 10.4289ZM2 10.6046L18 10.6046L18 9.40464L2 9.40464L2 10.6046Z","fill":"#C2C2C2"}));
}

ArrowRightIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ArrowRightIcon;

ArrowRightIcon.default = ArrowRightIcon;
